import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { formatDate, formatIsoDay, formatTRY } from "@/lib/format";
import { amountInWords } from "@/lib/amountWords";
import { CompanyHead, Sign } from "@/components/print/CompanyHead";

export default function PrimReceipt() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [c, setC] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/prim/payments/${id}`).then(({ data }) => setP(data)).catch((e) => setErr(apiError(e, "Makbuz yüklenemedi")));
    api.get("/settings/company").then(({ data }) => setC(data)).catch(() => setC({}));
  }, [id]);
  useEffect(() => { if (p && c) setTimeout(() => window.print(), 400); }, [p, c]);
  if (err) return <div className="p-8 text-rose-600" data-testid="prim-receipt-error">{err}</div>;
  if (!p || !c) return <div className="p-8 text-slate-400">Yükleniyor…</div>;
  const rows = [["Personel", p.user_name], ["Ödeme No", p.payment_no], ["Ödeme Tarihi", formatIsoDay(p.date)], ["Ödeme Hesabı", p.account_name], ["Kaydeden", p.created_by_name]];
  return (
    <div className="bg-slate-100 min-h-screen print:bg-white" data-testid="prim-receipt-page">
      <div className="max-w-[210mm] mx-auto py-4 print:hidden flex justify-between items-center">
        <span className="text-sm text-slate-600">Prim Ödeme Makbuzu · {p.payment_no}</span>
        <button onClick={() => window.print()} className="h-9 px-3 rounded bg-slate-900 text-white text-sm flex items-center gap-1" data-testid="prim-receipt-print"><Printer className="h-4 w-4" />Yazdır / PDF</button>
      </div>
      <div className="max-w-[210mm] mx-auto bg-white p-[12mm] shadow print:shadow-none print:p-0 text-slate-900">
        <CompanyHead c={c} title="PRİM ÖDEME MAKBUZU" no={p.payment_no} sub={`Tarih ${formatIsoDay(p.date)}`} />
        <table className="w-full text-[12px] mb-4"><tbody>{rows.map(([k, v]) => <tr key={k} className="border-b border-slate-200"><td className="py-1 text-slate-500 w-40">{k}</td><td className="font-semibold">{v}</td></tr>)}</tbody></table>
        <div className="text-[12px] font-semibold mb-1">Dönem Dağılımı</div>
        <table className="w-full text-[12px] border-collapse" data-testid="prim-receipt-allocations">
          <thead><tr className="border-b border-slate-900 text-left"><th className="py-1">Dönem</th><th>Prim No</th><th className="text-right">Tutar</th></tr></thead>
          <tbody>{p.allocations.map((a) => <tr key={a.run_id} className="border-b border-slate-200" data-testid={`prim-receipt-alloc-${a.period}`}><td className="py-1">{a.period_label}</td><td className="font-mono">{a.run_no}</td><td className="text-right font-mono">{formatTRY(a.amount)}</td></tr>)}</tbody>
          <tfoot><tr className="font-bold"><td className="pt-1" colSpan={2}>Toplam Ödenen</td><td className="text-right font-mono" data-testid="prim-receipt-total">{formatTRY(p.amount)}</td></tr></tfoot>
        </table>
        <div className="mt-3 border border-slate-300 p-2 text-[12px]" data-testid="prim-receipt-words"><b>Yazıyla:</b> {amountInWords(p.amount)}</div>
        {p.note && <div className="mt-2 text-[12px]"><b>Not:</b> {p.note}</div>}
        <p className="mt-4 text-[12px]">Yukarıda dönemleri belirtilen satış primi tutarını {p.account_name} hesabından eksiksiz teslim aldım.</p>
        <Sign labels={["Ödemeyi Yapan", "Teslim Alan (Personel)", "Onaylayan"]} />
        <div className="mt-8 text-[10px] text-slate-400">Yazdırma: {formatDate(new Date().toISOString())} · Baskı sayısı {p.print_count}</div>
      </div>
    </div>
  );
}
